import * as Icons from "lucide-react";

export const TrustBadges = ({ items, onDark = false, className = "" }) => {
  const color = onDark ? "var(--gold)" : "var(--text-dark)";
  return (
    <ul
      className={`flex flex-wrap gap-x-7 gap-y-3 ${className}`}
      data-testid="trust-badges-row"
    >
      {items.map((b) => {
        const Ico = Icons[b.icon] || Icons.Check;
        return (
          <li key={b.label} className="flex items-center gap-2.5">
            <Ico size={20} strokeWidth={1.5} style={{ color: "var(--gold)" }} />
            <span
              style={{
                color,
                fontSize: "14px",
                fontWeight: 500,
                letterSpacing: "0.01em",
              }}
            >
              {b.label}
            </span>
          </li>
        );
      })}
    </ul>
  );
};
